import type { SiteContent } from "../siteData";

type SpotifyEmbedProps = {
  spotify: SiteContent["spotify"];
};

export function SpotifyEmbed({ spotify }: SpotifyEmbedProps) {
  return (
    <section className="section section--black" aria-label="Music player">
      <div className="container container--wide">
        <iframe
          className="spotifyEmbed"
          title={spotify.title}
          src={spotify.src}
          width="100%"
          height="500"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="eager"
        />
      </div>
    </section>
  );
}
